module.exports = __webpack_public_path__ + "static/media/tour-3.a3f52a43.jpg";